import React from 'react';
import { Button } from 'antd';
import 'baseComponents/LinkComponent/linkComponent.scss';

type LinkPropsClick = {
  onClick: () => void;
  href?: never;
};
type LinkPropsHref = {
  onClick?: never;
  href: string;
};
interface Props {
  label: string;
  uppercase?: boolean;
  disabled?: boolean;
  className?: string;
}

export const LinkComponent: React.FC<
  Props & (LinkPropsClick | LinkPropsHref)
> = (props) => {
  return (
    <Button
      className={`link-component ${props.uppercase ? 'uppercase' : ''} ${
        props.className
      }`}
      type='link'
      disabled={props.disabled}
      onClick={props.onClick}
      href={props.href}
    >
      {props.label}
    </Button>
  );
};
